import { IPromise } from 'angular';
import { ICommand, IQuery } from 'core-ts-types';
import { CustomTextQuery, IReportConfigEntry, ReportConfigService } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import * as moment from 'moment';
import { IContentTileExpectedObj } from 'ui-ng-content-tile';
import { PriorityFeedCapabilityConfiguration } from '../../configuration';

export class FeedContainerController {
  private feedItems: IContentTileExpectedObj[];
  private schedule: IContentTileExpectedObj;
  private holds: IContentTileExpectedObj;
  private conversations: IContentTileExpectedObj;
  private appointments: IContentTileExpectedObj;
  private appointmentReqs: IContentTileExpectedObj;
  private reminders: IContentTileExpectedObj;
  private events: IContentTileExpectedObj;
  private todos: IContentTileExpectedObj;
  private studyBuddies: IContentTileExpectedObj;
  private surveys: IContentTileExpectedObj[];
  private reports: IContentTileExpectedObj;
  public numberItems: number;
  public hasHoldsThatNeedAttention: boolean;
  private reminderEnabled: boolean;
  private holdsCount: number;
  private isMobile: boolean;
  public isTogglingMore?: IPromise<undefined>;
  private reportConfig: IReportConfigEntry[];
  private activeReportConfig: IReportConfigEntry[];
  private hasPriorityFeedItems: boolean;
  isKnowledgeBotEnabled: boolean;

  constructor(
    private loadPriorityFeedDataCommand: ICommand,
    private $timeout: ng.ITimeoutService,
    private ngPriorityFeedCapabilityConfiguration: PriorityFeedCapabilityConfiguration,
    private ngReportConfigService: ReportConfigService,
    private ngCustomTextQuery: CustomTextQuery,
    private initOpenableElementsCommand: ICommand,
    private loadKBNameCommand: ICommand
  ) {
    this.isTogglingMore = undefined;
    this.reminderEnabled = this.ngPriorityFeedCapabilityConfiguration.config.isReminderEnabled;
    this.isMobile = this.ngPriorityFeedCapabilityConfiguration.config.isMobile;
    this.isKnowledgeBotEnabled = this.ngPriorityFeedCapabilityConfiguration.config.isKnowledgeBotEnabled;
  }

  $onInit(): void {
    if (this.isKnowledgeBotEnabled) {
      this.loadKBNameCommand();
    }
    this.initOpenableElementsCommand();
    this.holdsCount = 0;
    this.hasHoldsThatNeedAttention = false;
    return;
  }
}

export class FeedContainerComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-priority-feed/src/components/feed_container/feed_container.html';
  public controller: any = FeedContainerController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    studyBuddies: '<',
    schedule: '<',
    holds: '<',
    conversations: '<',
    appointments: '<',
    appointmentReqs: '<',
    reminders: '<',
    events: '<',
    todos: '<',
    surveys: '<',
    holdsCount: '<',
    hasHoldsThatNeedAttention: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/components/feed_container/feed_container.ts